import React, { Component } from "react";
import MemberForm from "./MemberForm";
import ContentHeader from "./ContentHeader";
import { get, list, create, update } from "../actions";
import { connect } from "react-redux";

class Member extends Component {
  componentDidMount() {
    this.props.fetchLookups();
    if (this.props.match.params.id) {
      this.props.fetchMember(this.props.match.params.id);
    }
  }

  render() {
    let { member, lookups, saveMember } = this.props;
    const renderMode = !!this.props.match.params.id ? "Edit" : "Add";
    const mode = `${renderMode} member`;
    return (
      <div>
        <ContentHeader title={mode} />
        <MemberForm
          member={member}
          saveMember={saveMember}
          lookups={lookups}
          {...this.props}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    lookups: state.memberLookups,
    member: state.members.currentMember || {}
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchMember(id) {
      dispatch(get("member", id));
    },
    saveMember(data) {
      if (data.id) {
        dispatch(update("member", data));
      } else {
        dispatch(create("member", data));
      }
    },
    fetchLookups() {
      dispatch(list("member_lookups"));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Member);



// WEBPACK FOOTER //
// ./src/components/Member.js